export const VALIDACAO_LABELS = {
  QT: {
    short: "Qtde Total",
    full: "Quantidade total de itens no pedido",
    icon: "cil-layers",
    grupo: "quantidade",
    help: "Concede desconto com base na quantidade total de itens no pedido. Ex: desconto de 10% em produtos da marca X quando o pedido tiver 10 ou mais itens dessa marca.",
  },
  QD: {
    short: "Qtde Distinta",
    full: "Quantidade de itens diferentes no pedido",
    icon: "cil-list",
    grupo: "quantidade",
    help: "Concede desconto com base na quantidade de itens distintos (diferentes) no pedido. Ex: desconto de 10% em produtos da marca X quando houver 5 ou mais produtos diferentes dessa marca.",
  },
  VL: {
    short: "Valor Mínimo",
    full: "Valor mínimo do pedido",
    icon: "cil-dollar",
    grupo: "valor",
    help: "Concede desconto quando o valor total de produtos de um segmento atingir um valor mínimo em R$. Ex: desconto de 10% em produtos da marca Home quando houver R$500 ou mais em produtos da marca Games.",
  },
  VD: {
    short: "Valor + Qtde Distinta",
    full: "Valor mínimo e quantidade distinta de itens",
    icon: "cil-calculator",
    grupo: "valor",
    help: "Combina valor mínimo em R$ com quantidade de itens distintos. Ex: desconto de 10% em produtos da marca Games quando houver 5+ produtos diferentes e valor total >= R$200.",
  },
  VQ: {
    short: "Valor + Qtde Total",
    full: "Valor mínimo e quantidade total de itens",
    icon: "cil-chart-line",
    grupo: "valor",
    help: "Combina valor mínimo em R$ com quantidade total de itens. Ex: desconto para produtos cujo valor total atinja R$100 e quantidade mínima seja 10 ou mais unidades por item.",
  },
  QQ: {
    short: "Qtde Distinta + Total",
    full: "Quantidade distinta e total de itens",
    icon: "cil-options",
    grupo: "quantidade",
    help: "Combina quantidade de itens distintos com quantidade total. Ex: desconto de 10% em produtos da marca Games quando houver pelo menos 2 produtos distintos e soma total >= 4 unidades.",
  },
  XX: {
    short: "Valor + Qtdes",
    full: "Valor mínimo, quantidade distinta e total de itens",
    icon: "cil-grid",
    grupo: "combinado",
    help: "Validação completa combinando valor mínimo em R$, quantidade de itens distintos e quantidade total. Todas as condições precisam ser atendidas simultaneamente.",
  },
  PM: {
    short: "Percentual Mínimo",
    full: "Percentual mínimo utilizando o valor do pedido",
    icon: "cil-speedometer",
    grupo: "percentual",
    help: "Concede desconto quando produtos de um segmento representam um percentual mínimo do valor total do pedido. Ex: desconto de 10% em produtos da marca Games quando representarem entre 20% e 40% do valor do pedido. Cálculo: (valor do segmento / valor total do pedido) × 100.",
  },
  PMD: {
    short: "Percentual por Segmento",
    full: "Percentual mínimo por segmento da regra",
    icon: "cil-bar-chart",
    grupo: "percentual",
    help: "Percentual mínimo calculado por segmento da regra de aplicação. Será considerado o valor em R$ do segmento da regra de aplicação para calcular o percentual que a regra de validação tem sobre ela.",
  },
};

export const VALIDACAO_GRUPOS = {
  quantidade: { label: "Por Quantidade", ordem: 1 },
  valor: { label: "Por Valor", ordem: 2 },
  percentual: { label: "Por Percentual", ordem: 3 },
  combinado: { label: "Combinado", ordem: 4 },
};

export const TIPO_LABELS = {
  SEGMENTACAO: {
    label: "Segmento",
    description: "Regras baseadas em segmentos de produtos",
    icon: "cil-layers",
  },
  PERSONALIZADO: {
    label: "Combo",
    description: "Regras personalizadas com segmentos e produtos",
    icon: "cil-puzzle",
  },
  MIX: {
    label: "Mix de Produtos",
    description: "Lista específica de produtos participantes",
    icon: "cil-basket",
  },
};

export const CONFIG_HELP = {
  validarTodasRegras: "Quando ativo, todas as regras da campanha precisam ser atendidas para aplicar o desconto. Caso contrário, basta uma regra válida.",
  validarTodasRegrasMix: "Quando ativo, o pedido precisa conter todos os produtos do mix para que a campanha seja aplicada.",
  validarPorRegra: "Determina se a validação será individual por regra ou se será uma única validação para todas as regras.",
  consideraQtdeEstoque: "Valida a quantidade disponível em estoque antes de aplicar a campanha.",
  validaSobrePromocao: "Permite que a campanha valide produtos que já estejam em promoção (cadastrados na V_BDTI_PRECOPROMOCIONAL ou V_BDTI_DESCONTO com aplica automático ativado).",
  aplicarSobrePromocao: "Aplica o desconto da campanha em produtos que já possuem preço promocional. Atenção: quando o parâmetro 'Sempre priorizar promoções sobre descontos de campanhas' está ativo, o sistema prioriza o preço promocional e não acumula com desconto de campanha.",
  acumulaDesconto: "Permite acumular descontos de múltiplas campanhas no mesmo produto.",
  usaNaoCompra: "Ativa a validação de não compra para as regras da campanha. Quando habilitado, exibe nos segmentos da regra um campo adicional para filtrar apenas produtos que nunca foram adquiridos pelo cliente ou que não foram comprados dentro de um período específico.",
  aplicarSobreNegociacao: "Aplica o desconto da campanha em produtos que possuem negociação de preço vinculada.",
};

export const RESTRICAO_LABELS = {
  FILIAL: "Filial",
  CLIENTE: "Cliente",
  REGIAO: "Região (Tab. Preço)",
  REGIAO_ITEM: "Região (Item)",
  REGIAO_RCA: "Região (RCA)",
  REDE: "Rede",
  PRACA: "Praça",
  ATIVIDADE: "Atividade",
  REPRESENTANTE: "Representante",
  SUPERVISOR: "Supervisor",
  UF: "UF",
  PLANO_PAGAMENTO: "Plano de Pagamento",
};

export const CANAIS = [
  { key: "aplicab2b", label: "B2B", icon: "shopping-basket" },
  { key: "aplicacallcenter", label: "Callcenter", icon: "headset" },
  { key: "aplicafv", label: "Força de Vendas", icon: "user-tie" },
];

export function getValidacaoLabel(codigo) {
  return VALIDACAO_LABELS[codigo]?.short || codigo;
}

export function getTipoLabel(codigo) {
  return TIPO_LABELS[codigo]?.label || codigo;
}

export function getRestricaoLabel(tipo) {
  return RESTRICAO_LABELS[tipo] || tipo;
}

export function getCanaisAtivos(item) {
  return CANAIS.filter((canal) => item[canal.key]);
}
